<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M41.2 4c-.2-.2-.4-.5-.6-.7-.9-.8-2.1-1.3-3.4-1.3H10.8c-1.3 0-2.5.5-3.4 1.3-.2.2-.4.5-.6.7-.5.7-.8 1.6-.8 2.5v35.3c.2 2.1 1.9 3.9 4.1 4.1 1.8-.2 2.8-1 3.7-1.6.8-.6 1.5-1.1 2.8-1.1 1.4 0 2 .5 2.8 1.1 1 .7 2.2 1.7 4.5 1.7s3.5-.9 4.5-1.7c.9-.6 1.5-1.1 2.8-1.1s2 .5 2.8 1.1c.9.6 1.9 1.4 3.7 1.6 2.2-.3 4-2 4.1-4.2V6.5c.2-.9-.1-1.8-.6-2.5zM26.4 26c-.4.4-.9.6-1.5.6h-8c-1.2 0-2.1-.9-2.1-2.1 0-.6.2-1.1.6-1.5.4-.4.9-.6 1.5-.6h8c1.2 0 2.1.9 2.1 2.1 0 .6-.2 1.1-.6 1.5zm4.7-9.7H16.9c-1.2 0-2.1-.9-2.1-2.1s.9-2.1 2.1-2.1h14.2c1.2 0 2.1.9 2.1 2.1s-.9 2.1-2.1 2.1z" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
